import styled, { css } from 'styled-components'

const Container = styled.div`
	position: relative;
	background-color: transparent;
	margin: 4px 0px;
`

const Input = styled.input`
	min-height: 40px;
	max-height: 40px;

	background-color: transparent;
	font-family: 'Century Gothic';
	padding: 16px 0 16px 20px;
	border: none;
	width: 100%;
	font-weight: normal;
	border-radius: 5px;
	padding: 16px 20px;
	background-color: #f6f8fb;
	font-size: 12px;
	display: flex;
	align-items: center;
	letter-spacing: 0.02em;
	color: #44344f;

	/** override Google autofill */

	&:-webkit-autofill,
	&:-webkit-autofill:hover,
	&:-webkit-autofill:focus,
	&:-webkit-autofill:active {
		-webkit-box-shadow: 0 0 0 30px #f6f8fb inset !important;
		color: #44344f !important;
	}

	::placeholder {
		font-weight: normal;
		color: #7c7184;
	}

	&:focus {
		outline: none;
	}

	${({ error }) =>
		!!error &&
		css`
			border: 2px solid red;
		`}
`

const Label = styled.label`
	font-weight: normal;
	color: #7c7184;
	font-size: 12px;
	margin-left: 19px;
`

const CharacterCount = styled.div`
	font-weight: semi-bold;
	color: #44344f;
	font-size: 10px;
	white-space: nowrap;
`

const Subtext = styled.div`
	color: #b0b0b0;
	font-size: 14px;
	white-space: nowrap;
	padding-left: 20px;
`

export { Input, Label, Container, CharacterCount, Subtext }
